import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../utils/date';
import RaceCardLink from '../../shared/links/RaceCardLink';

const TravellersRaceCell = props => (
    <RaceCardLink {...props} >
        {formatDate(props.raceDatetime, 'h:mm')}
    </RaceCardLink>
);

TravellersRaceCell.propTypes = {
    raceDatetime: PropTypes.string,
};

export default TravellersRaceCell;



// WEBPACK FOOTER //
// ./src/js/course/signposts/TravellersRaceCell.jsx